import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXilinxComponent } from './simple-icons-xilinx.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXilinxComponent ],
    exports:      [ SimpleIconsXilinxComponent ],
    bootstrap:    []
})
export class SimpleIconsXilinxModule {}
